import { useEffect, useRef } from 'react'

// Renders a small pixel matrix to a canvas, scaled up with hard edges.
// matrix: array of strings, each char is a palette key ('.' = transparent)
export default function PixelSprite({ matrix, palette, scale = 6 }) {
  const ref = useRef(null)

  useEffect(() => {
    const canvas = ref.current
    if (!canvas) return
    const h = matrix.length
    const w = matrix[0].length
    canvas.width = w
    canvas.height = h
    const ctx = canvas.getContext('2d')
    ctx.clearRect(0, 0, w, h)
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        const c = matrix[y][x]
        if (c === '.') continue
        ctx.fillStyle = palette[c] || '#fff'
        ctx.fillRect(x, y, 1, 1)
      }
    }
    canvas.style.width = `${w * scale}px`
    canvas.style.height = `${h * scale}px`
  }, [matrix, palette, scale])

  return <canvas ref={ref} className="pixel-sprite" aria-hidden="true" />
}
